module.exports = __webpack_public_path__ + "static/media/palm_leaves_05-[Converted].f35047f1.png";